const PSG_MQ = '(min-width: 768px)';
const PSG_FLICKITY_POLL_MS = 50;
const PSG_FLICKITY_POLL_MAX = 50;

function getFlickity() {
  const tv = typeof window !== 'undefined' ? window.themeVendor : undefined;
  if (tv && typeof tv.Flickity === 'function') {
    return tv.Flickity;
  }
  if (typeof window !== 'undefined' && typeof window.Flickity === 'function') {
    return window.Flickity;
  }
  if (typeof Flickity === 'function') {
    return Flickity;
  }
  return null;
}

function psgFlickityOptions(isDesktop, slideCount) {
  const multi = slideCount > 1;
  return {
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    freeScroll: false,
    pageDots: !isDesktop && multi,
    prevNextButtons: false,
    draggable: multi,
    cellSelector: '.product-story-gallery__cell',
  };
}

function setupCarousel(root, carousel) {
  if (root.getAttribute('data-psg-init') === '1') return;

  const FlickityClass = getFlickity();
  if (!FlickityClass) {
    console.error('Flickity class not found during setup.');
    return;
  }

  root.setAttribute('data-psg-init', '1');

  const slideCount = parseInt(root.getAttribute('data-slide-count') || '0', 10);
  let flkty = null;
  const mediaQuery = window.matchMedia(PSG_MQ);

  function destroy() {
    if (flkty) {
      flkty.destroy();
      flkty = null;
    }
  }

  function create() {
    destroy();
    try {
      flkty = new FlickityClass(carousel, psgFlickityOptions(mediaQuery.matches, slideCount));

      const imgs = carousel.querySelectorAll('img');
      if (imgs.length === 0) return;

      let imgsLoaded = 0;
      const onMaybeAllLoaded = () => {
        imgsLoaded += 1;
        if (imgsLoaded === imgs.length && flkty) flkty.resize();
      };

      imgs.forEach((img) => {
        if (img.complete) {
          onMaybeAllLoaded();
        } else {
          img.addEventListener('load', onMaybeAllLoaded);
        }
      });
    } catch (e) {
      console.error('Failed to initialize Flickity:', e);
    }
  }

  const prevBtn = root.querySelector('[data-psg-prev]');
  const nextBtn = root.querySelector('[data-psg-next]');

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (flkty) flkty.previous();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (flkty) flkty.next();
    });
  }

  create();

  let mqTimer;
  function onMediaChange() {
    clearTimeout(mqTimer);
    mqTimer = setTimeout(() => {
      create();
    }, 80);
  }

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', onMediaChange);
  } else {
    mediaQuery.addListener(onMediaChange);
  }
}

function initProductStoryGallery(root) {
  if (root.getAttribute('data-psg-init') === '1') return;

  const carousel = root.querySelector('.product-story-gallery__carousel');
  if (!carousel) return;

  if (!getFlickity()) {
    let attempts = 0;
    const checkFlickity = setInterval(() => {
      attempts += 1;
      if (getFlickity()) {
        clearInterval(checkFlickity);
        setupCarousel(root, carousel);
      } else if (attempts >= PSG_FLICKITY_POLL_MAX) {
        clearInterval(checkFlickity);
        console.error('Flickity failed to load for Product Story Gallery. Check if it is bundled in the theme.');
      }
    }, PSG_FLICKITY_POLL_MS);
    return;
  }

  setupCarousel(root, carousel);
}

function bootProductStoryGallery() {
  document.querySelectorAll('[data-product-story-gallery]').forEach(initProductStoryGallery);
}

bootProductStoryGallery();

document.addEventListener('shopify:section:load', bootProductStoryGallery);
